class MainCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.collectionReadOnlyKey = "dded12a5497d69acfcfd27f2026ca410";
    this.collectionHandle = this.getAttribute("handle");

    this.productsSliders = this.querySelectorAll(".productsSlider");

    this.collectionPageProductsBestSellingSlider = new Swiper(".bestSeller", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next.best",
        prevEl: ".swiper-button-prev.best",
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1425: { slidesPerView: 5 },
      },
    });

    this.collectionPageProductsLatestSlider = new Swiper(".latest", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1425: { slidesPerView: 5 },
        },
      });

    document.addEventListener("DOMContentLoaded", (event) => {
        this.fetchCollectionProducts.bind(this)(10, "BEST_SELLING")
        .then(products => {
            const wrapper = this.productsSliders[0].querySelector(".swiper-wrapper");
            products.forEach(product => {
                console.log(product);
                
                const productCard = document.createElement("div");
                productCard.setAttribute("class", "card card--product h-full card--product-contained card--product-compare relative flex swiper-slide height-full");
                productCard.innerHTML = this.getProductCardHtmlString(product);
                wrapper.appendChild(productCard);
            })
        })
        .catch(error => console.log(error));

        this.fetchCollectionProducts.bind(this)(10, "BEST_SELLING")
        .then(products => {
            const wrapper = this.productsSliders[1].querySelector(".swiper-wrapper");
            products.forEach(product => {
                console.log(product);
                
                const productCard = document.createElement("div");
                productCard.setAttribute("class", "card card--product h-full card--product-contained card--product-compare relative flex swiper-slide height-full");
                productCard.innerHTML = this.getProductCardHtmlString(product);
                wrapper.appendChild(productCard);
            })
        })
        .catch(error => console.log(error));
    });
  }

  getProductCardHtmlString(product) {
    return `
        <div class="card__media has-hover-image relative">
            <img width="400" height="auto" src="${product.images[0]}" alt="${product.title}"/>
        </div>
        <div class="card__info-inner flex flex-col-space-between h-full w-full">
            <p class="card__title font-bold mb-1 shrink-text" style="height:50px;">
                <a class="card-link text-current js-prod-link card-title">${product.title}</a>
            </p>
            <div>
                <div class="rating inline-block align-middle" role="img" aria-label="5.0 out of 5.0 stars">
                    <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5.0;">★★★★★</span>
                </div>
                <div class="rating__count inline-block align-middle text-sm">(32)</div>
            </div>
            <div
                class="flex grow items-end"
                style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                "
            >
                <div class="price price--bottom">
                    <div class="price__default" style="color: #14465f">
                    <span class="price__from" style="font-weight: bold; font-size: 16px"
                        >From
                        <span class="transcy-money">$${product.priceRange.maxVariantPrice.amount}</span>
                    </span>
                    <div class="price-current__div"></div>
                    <s class="price__was"></s>
                    </div>
                    <div class="unit-price relative" hidden="">
                    <span class="visually-hidden">Unit price</span>
                    <span class="unit-price__price"></span>
                    <span class="unit-price__separator"> / </span>
                    <span class="unit-price__unit"></span>
                    </div>
                    <div class="price__no-variant" hidden="">
                    <strong class="price__current">Unavailable</strong>
                    </div>
                </div>
            </div>
        </div>
    `
  }

  fetchCollectionProducts(limit, filter) {
    return fetch("https://wholedent.com/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.collectionReadOnlyKey,
      },
      body: JSON.stringify({
        query: `
                    {
                      collection(handle: "${this.collectionHandle}") {
                        title
                        description
                        products(first: ${limit}, sortKey: ${filter}) {
                          edges {
                            node {
                              id
                              title
                              handle
                              description
                              createdAt
                              productType
                              vendor
                              tags
                              images(first: 1) {
                                edges {
                                  node {
                                    url
                                  }
                                }
                              }
                              priceRange {
                                minVariantPrice {
                                  amount
                                  currencyCode
                                }
                                maxVariantPrice {
                                  amount
                                  currencyCode
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  `,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const products = data.data.collection.products.edges.map(
          (prodEdge) => {
            return {
                ...prodEdge.node,
                images: prodEdge.node.images.edges.map(edge => edge.node.url)
            }

          }
        );
        return products;
      })
      .catch((err) => console.error(err));
  }
}

customElements.define("main-collection-section", MainCollectionSection);
